import { useEffect, useState } from 'react';
import { getReadAnnouncementIds, subscribeReadAnnouncements } from '../utils/announcement';

export function useReadAnnouncements(): number[] {
  const [ids, setIds] = useState<number[]>(() => getReadAnnouncementIds());

  useEffect(() => subscribeReadAnnouncements(() => {
    setIds(getReadAnnouncementIds());
  }), []);

  return ids;
}
